import { useMemo } from "react";

export function useChunkedArray<T>(values: T[], chunkSize: number): T[][] {
    const chunks = useMemo(() => {
        const result: T[][] = [];
        if (chunkSize <= 0) {
            return result;
        }
        for (let i = 0; i < values.length; i += chunkSize) {
            result.push(values.slice(i, i + chunkSize));
        }
        return result;
    }, [values, chunkSize]);

    return chunks;
};
